import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { cn } from '../utils/class-names';

const Toast = ({ className, richColors = true, ...props }: ToasterProps) => {
  return (
    <Sonner
      richColors={richColors}
      className={cn(
        'toaster group',
        '[&_[data-sonner-toast]]:bg-white [&_[data-sonner-toast]]:border-gray-200',
        '[&_[data-sonner-toast]]:text-gray-900 [&_[data-sonner-toast]]:shadow-lg',
        '[&_[data-sonner-toaster]]:bg-white [&_[data-sonner-toaster]]:text-gray-950',
        "[&_[data-rich-colors='true']_[data-sonner-toast][data-type='success']]:bg-green-50 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='success']]:border-green-200 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='success']]:text-green-900",
        "[&_[data-rich-colors='true']_[data-sonner-toast][data-type='error']]:bg-red-50 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='error']]:border-red-200 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='error']]:text-red-900",
        "[&_[data-rich-colors='true']_[data-sonner-toast][data-type='warning']]:bg-yellow-50 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='warning']]:border-yellow-200 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='warning']]:text-yellow-900",
        "[&_[data-rich-colors='true']_[data-sonner-toast][data-type='info']]:bg-blue-50 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='info']]:border-blue-200 [&_[data-rich-colors='true']_[data-sonner-toast][data-type='info']]:text-blue-900",
        className,
      )}
      {...props}
    />
  );
};

export { Toast };
